import {gsap, SplitText} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class DataTextAppear {
	constructor() {
		const items = document.querySelectorAll("[data-text-appear]");

		// Mouvement réduit : rendre les éléments visibles immédiatement sans animation
		if (GlobalVariables.reducedMotion) {
			items.forEach(item => gsap.set(item, { opacity: 1 }));
			return;
		}

		document.fonts.ready.then(() => {
			items.forEach(item => {
				gsap.set(item, {opacity: 1});
				const delay = item.dataset.textAppearDelay ?? 0;

				SplitText.create(item, {
					type: "lines",
					linesClass: "line",
					autoSplit: true,
					mask: "lines",
					onSplit: (self) => {
						return gsap.from(self.lines, {
							delay: delay,
							duration: 2,
							yPercent: 100,
							opacity: 0,
							stagger: 0.15,
							ease: "expo.out",
							scrollTrigger: {
								trigger: item,
								start: "top 90%",
							}
						});
					}
				});
			});
		});
	}
}
